import { gql } from '@apollo/client';

export const PUBLISH_TO_RAD = gql`
    query publishToRAD($partyId: Int!) {
        partyPublishToRAD(data: { partyId: $partyId }) {
            result
        }
    }
`;
